export default "__VITE_ASSET__c7f3fcdc__"